import { render, staticRenderFns } from "./configuration-local-accounting-billable-clients-modal-basic-form.vue?vue&type=template&id=7dec2cf3&"
import script from "./configuration-local-accounting-billable-clients-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-accounting-billable-clients-modal-basic-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports